import "./App.css";
import * as React from "react";
import {
  Route,
  Routes,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import Home from "./pages/Home";
import LoginHub from "./pages/Login/LoginHub";
import About from "./pages/About";
import Features from "./pages/Features";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import CampaignHeader from "./common/components/CampaignHeader";
import Header from "./common/components/Header";
import Footer from "./common/components/Footer";
import CampaignFooter from "./common/components/CampaignFooter";
import scroll from "./assets/images/rocket.png";
import { Helmet } from "react-helmet";
import Alerts from "./common/components/Alerts";
import CampaignHome from "./pages/Campagin/CampaignHome";
import AddNewCampaign from "./pages/Campagin/AddNewCampaignHub/AddNewCampaign";
import EditPayment from "./pages/Campagin/Settings/EditPayment";
import EditProfile from "./pages/Campagin/Settings/EditProfile";
import CampaignSites from "./pages/Campagin/CampaignSites";
import { fetchBlogPosts } from "./api/MarketingApi";
import Blog from "./pages/Blog/Blog";
import BlogPostContent from "./pages/Blog/BlogPostContent";
import Sitemap from "./Sitemap";
import CampaignAdsHome from "./pages/CampaignAdvertisements/CampaignAdsHome";
import PremiumFeatures from "./pages/PremiumFeatures";
import PageNotFound from "./pages/PageNotFound";

export const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace={true} />;
  }

  return children;
};

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  //For iPhone users to be able to use the hamburger menu
  document.addEventListener("touchstart", function () {}, false);
  window.axios = axios;

  // Alert states
  const [alertState, setAlertState] = React.useState({
    success: false,
    error: false,
    warning: false,
    info: false,
    none: false,
  });

  // Alert Message
  const [alertMessage, setAlertMessage] = React.useState("");

  const onTriggerAlert = (flag) => {
    setAlertState({
      ...alertState,
      [flag]: !alertState[flag],
    });

    // Cleanup alert after 5 secs
    setTimeout((flag) => {
      setAlertState({
        ...alertState,
        [flag]: !alertState[flag],
      });
    }, "4000");
  };

  const [blogList, setBlogList] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const validBlogs = React.useMemo(
    () =>
      (blogList || []).filter(
        (blog) =>
          typeof blog?.slug === "string" &&
          blog.slug.trim() !== "" &&
          blog.slug !== "undefined",
      ),
    [blogList],
  );

  let FetchPosts = async () => {
    try {
      let resp = await fetchBlogPosts({});
      setBlogList(resp);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    try {
      FetchPosts();
    } catch (error) {
      console.log(error);
    }
  }, []);

  React.useEffect(() => {
    if (location.pathname === "/ads") {
      window.location.href = "https://www.buildidads.com";
    }
  }, [location.pathname]);

  // if (isLoading) {
  //   return <div>Loading...</div>; // Render a loading state until blogList is fetched
  // }

  return (
    !isLoading && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "100vh",
          backgroundColor: "#f2f2f2",
        }}
      >
        {/* Conditional rendering of Header */}
        {!["/sitemap", "/faqapp"].includes(window.location.pathname) && // Exclude "/sitemap" and "/faqapp" paths
        [
          "/",
          "/login",
          "/about",
          "/features",
          "/faqs",
          "/premium-features",
          "/contact",
          "/blog",
          ...(validBlogs.map((blog) => `/${blog.slug}`) || []),
        ].includes(window.location.pathname) ? (
          <Header />
        ) : (
          <></>
        )}
        {/* 
      {window.location.pathname !== "/" &&
        window.location.pathname !== "/login" &&
        !blogList?.map((blog) => window.location.pathname === `/${blog.slug}`) &&
        window.location.pathname !== "/about" &&
        window.location.pathname !== "/features" &&
        window.location.pathname !== "/faqs" &&
        window.location.pathname !== "/contact" &&
        window.location.pathname !== "/blog" &&
        window.location.pathname !== "/faqapp" ? (
        <CampaignHeader />
      ) : (
        <></>
      )} */}

        <Routes>
          <Route path="" element={<Home />} />
          <Route path="sitemap" element={<Sitemap blogList={blogList} />} />

          <Route path="faqapp" element={<Faq />} />

          <Route
            path="Campaign-Home"
            element={
              <RequireAuth>
                <CampaignAdsHome
                  onTriggerAlert={(flag) => onTriggerAlert(flag)}
                  setAlertMessage={setAlertMessage}
                />
                {/* <CampaignHome onTriggerAlert={(flag) => onTriggerAlert(flag)} setAlertMessage={setAlertMessage} /> */}
              </RequireAuth>
            }
          />

          <Route
            path="Campaign-sites"
            element={
              <RequireAuth>
                <CampaignSites
                  onTriggerAlert={(flag) => onTriggerAlert(flag)}
                  setAlertMessage={setAlertMessage}
                />
              </RequireAuth>
            }
          />
          <Route
            path="Add-New-Campaign"
            element={
              <RequireAuth>
                <AddNewCampaign
                  onTriggerAlert={(flag) => onTriggerAlert(flag)}
                  setAlertMessage={setAlertMessage}
                />
              </RequireAuth>
            }
          />
          <Route
            path="Edit-Payment"
            element={
              <RequireAuth>
                <EditPayment
                  onTriggerAlert={(flag) => onTriggerAlert(flag)}
                  setAlertMessage={setAlertMessage}
                />
              </RequireAuth>
            }
          />
          <Route
            path="Edit-Profile"
            element={
              <RequireAuth>
                <EditProfile
                  onTriggerAlert={(flag) => onTriggerAlert(flag)}
                  setAlertMessage={setAlertMessage}
                />
              </RequireAuth>
            }
          />

          <Route
            path="Login"
            element={
              <LoginHub
                onTriggerAlert={(flag) => onTriggerAlert(flag)}
                setAlertMessage={setAlertMessage}
              />
            }
          />

          <Route path="about" element={<About />} />
          <Route path="features" element={<Features />} />
          <Route path="premium-features" element={<PremiumFeatures />} />
          <Route path="faqs" element={<Faq />} />
          <Route path="contact" element={<Contact />} />
          <Route path="blog" element={<Blog />} />

          {/* Dynamic Blog Routes */}
          {validBlogs.map((blog) => (
            <Route
              key={blog.slug}
              path={blog.slug}
              // path={`/blog${blog.slug}`}
              element={<BlogPostContent post={blog} />} // Pass the blog post data to BlogPost component
            />
          ))}
          <Route
            path="*"
            element={
              <>
                <Header />
                <PageNotFound />
              </>
            }
          />

          {/* Default redirects back to home if you put a random link that doesn't have a path */}
          {/* <Route path="*" element={<Navigate to="/" replace={true} />} /> */}
        </Routes>

        {/* <Footer /> */}
        {window.location.pathname != "/faqapp" &&
        window.location.pathname != "/sitemap" ? (
          <CampaignFooter />
        ) : (
          <></>
        )}

        {/* Alert Popups */}
        <Alerts
          setAlertState={setAlertState}
          alertState={alertState}
          alertMessage={alertMessage}
          setAlertMessage={setAlertMessage}
          onTriggerAlert={(flag) => onTriggerAlert(flag)}
        />
      </div>
    )
  );
}

export default App;
